module.exports = __webpack_public_path__ + "static/media/ice4.5311e779.png";